import React, { useState, useEffect, useContext } from "react";
import { parseISO, format } from "date-fns";
import { toast } from "react-toastify";
import { FaCircle } from "react-icons/fa";
import { Context } from '../context/UserContext';
import MaestroService from "../services/MaestroService";
import SendToWarehouseModal from "./modals/SendToWarehouseModal"
import SendToManagementModal from "./modals/SendToManagementModal"
import RequestService from "../services/RequestService";
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import FinishModal from './modals/FinishModal';
import { MdCallMade } from "react-icons/md";
import { AiFillAlert } from "react-icons/ai";
import { IoIosSend } from "react-icons/io";
import InitiateRequestModal from "./modals/InitiateRequestModal";
import StatusRequests from "../enums/StatusRequests";
import { RiTimerLine } from "react-icons/ri";
import { startPolling } from "../utils/polling";


// Liberação temporária da tramitação no Maestro (em teste). Mesma regra
// aplicada no backend (MaestroController.EMAILS_LIBERADOS).
const EMAILS_TRAMITAR_MAESTRO = [
  'guilherme.alberto@amerinode.com.br',
  'junior.silva@amerinode.com.br',
  'jean.medeiros@amerinode.com.br',
];

function Home() {
  const { user } = useContext(Context);

  // Chamado que está sendo tramitado no momento (trava o botão da linha).
  const [tramitandoId, setTramitandoId] = useState(null);

  const podeTramitar = EMAILS_TRAMITAR_MAESTRO.includes(
    String(user?.email || '').toLowerCase()
  );

  const [sendToWarehouseModal, setSendToWarehouseModal] = useState(false);
  const [requestOnAnswerModal, setRequestOnAnswerModal] = useState();
  const [requestNroOnAnswerModal, setRequestNroOnAnswerModal] = useState();
  const [sendToManagementModal, setSendToManagementModal] = useState(false);
  const [requestOnMngtModal, setRequestOnMngtModal] = useState();
  // const [requestNroOnMngtModal, setRequestNroOnMngtModal] = useState();
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();
  // const [requestListNovos, setRequestListNovos] = useState([]);
  const [requestListNovos, setRequestListNovos] = useState({ requests: [], totalPages: 1 });
  const [requestListBackoffice, setRequestListBackoffice] = useState({ requests: [], totalPages: 1 });
  const [requestListEntregue, setRequestListEntregue] = useState({ requests: [], totalPages: 1 });

  const [currentPageNovos, setCurrentPageNovos] = useState(1);
  const [currentPageBackoffice, setCurrentPageBackoffice] = useState(1);
  const [currentPageEntregue, setCurrentPageEntregue] = useState(1);

  const [initiateRequestModal, setInitiateRequestModal] = useState(false)
  const [requestOnInitiateRequestModal, setRequestOnInitiateRequestModal] = useState()
  const [requestNroOnInitiateRequestModal, setRequestNroOnInitiateRequestModal] = useState()

  const [finishModal, setFinishModal] = useState(false);
  const [requestOnFinishModal, setRequestOnFinishModal] = useState();
  const [requestNroOnFinishModal, setRequestNroOnFinishModal] = useState();

  // implementar um estado para quando fechar qquer modal executar os useEffect enquanto não temos websocket api
  // const [closedAnyModal, setClosedAnyModal ] = useState(false);

  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');

  
  // ================= USEEFFECT PARA BUSCAR REQUESTS STATUS NOVO =================
  useEffect(()=>{
    const fetchRequests = async () => {
      const requestsNovos= await RequestService.getRequest('?status=NOVO', currentPageNovos);
      setRequestListNovos(requestsNovos);
    }
    // Chamada inicial
    fetchRequests();
    return startPolling(fetchRequests);
  }, [currentPageNovos, initiateRequestModal])


  // ================= USEEFFECT PARA BUSCAR REQUESTS STATUS BACKOFFICE =================
  useEffect(()=>{
    const fetchRequests = async () => {
      const status = 'BACKOFFICE'
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);
    
      const queryString = params.toString();
      const requestsBackoffice = await RequestService.getRequest(`?${queryString}`, currentPageBackoffice);
      setRequestListBackoffice(requestsBackoffice);
    }
    // Chamada inicial
    fetchRequests();
    return startPolling(fetchRequests);
  }, [currentPageBackoffice, endDate, search, startDate, initiateRequestModal, sendToWarehouseModal, sendToManagementModal])


  // ================= USEEFFECT PARA BUSCAR REQUESTS STATUS ENTREGUE =================
  useEffect(()=>{
    const fetchRequests = async () => {
      const requestsEntregue = await RequestService.getRequest('?status=ENTREGUE', currentPageEntregue);
      setRequestListEntregue(requestsEntregue);
    }
    // Chamada inicial
    fetchRequests();
    return startPolling(fetchRequests);
  }, [currentPageEntregue, finishModal])

  // ================= FIM USEEFFECT =================

  const handlePageChangeNovos = (newPage) => {
    if (newPage >= 1 && newPage <= requestListNovos.totalPages) {
      setCurrentPageNovos(newPage);
    }
  };

  const handlePageChangeBackoffice = (newPage) => {
    if (newPage >= 1 && newPage <= requestListBackoffice.totalPages) {
      setCurrentPageBackoffice(newPage);
    }
  };

  const handlePageChangeEntregue = (newPage) => {
    if (newPage >= 1 && newPage <= requestListEntregue.totalPages) {
      setCurrentPageEntregue(newPage);
    }
  };

  const handleAnswerRequest = async (ticketId, requestNro) => {
    setSendToWarehouseModal(true)
    setRequestOnAnswerModal(ticketId)
    setRequestNroOnAnswerModal(requestNro)
  };

  const handleGestao = async (ticketId, requestNro) => {
    setSendToManagementModal(true)
    setRequestOnMngtModal(ticketId)
    // setRequestNroOnMngtModal(requestNro)
  };

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const handleFinalizar = async (ticketId, requestNro) => {
    setFinishModal(true)
    setRequestOnFinishModal(ticketId)
    setRequestNroOnFinishModal(requestNro)
  };

  // Tramita o TA da Vivo (avisa que o atendimento do lado do Vision terminou).
  // O TA (idBoleto) e o carimbo são montados no backend a partir da Request.
  const handleTramitar = async (ticketId, idBoleto) => {
    if (!idBoleto) {
      toast.error("Este chamado não possui TA (boleto) para tramitar.");
      return;
    }
    if (!window.confirm(`Tramitar o TA ${idBoleto} na Vivo?\n\nIsso avisa a Vivo que o atendimento terminou do nosso lado.`)) {
      return;
    }

    setTramitandoId(ticketId);
    try {
      const data = await MaestroService.tramitar(ticketId);
      toast.success(data?.message || `TA ${idBoleto} tramitado com sucesso!`);
    } catch (error) {
      const resposta = error.response?.data;
      toast.error(resposta?.message || "Ops! Não foi possível tramitar o chamado.");
      console.error("Erro ao tramitar no Maestro:", resposta || error.message);
    } finally {
      setTramitandoId(null);
    }
  };

  const handleInitiateRequestModal = async (ticketId, requestNro) => {
    setInitiateRequestModal(true)
    setRequestOnInitiateRequestModal(ticketId)
    setRequestNroOnInitiateRequestModal(requestNro)
  };  

  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value);
  //   console.log(e.target.value)
  // };

  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
  };

  const renderFurtoVandalismoFlag = (request) => {
    if (!request?.isFurtoVandalismo) {
      return '-';
    }

    return (
      <div className="flex items-center justify-center gap-1 text-red-600 font-bold whitespace-nowrap">
        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
      </div>
    );
  };

  // ====== END FILTER FUNCTIONS ====== 


  return (
    <div className="flex w-full h-full justify-center items-center gap-3 py-4 px-3 bg-gray-200">

    <div className="flex 3xl:flex-col w-full min-h-full rounded-xl gap-2">

      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-4 bg-white">

          {/* Linha informativa sobre entregues aguardando fechamento */}
          {(() => {
            // Filtra chamados do tipo 'vital'
            const vitals = requestListEntregue.requests.filter(
              (request) => request.tipoAtendimento === 'vital'
            );

            // Filtra chamados do tipo 'programado' cujo slaDate vence em até 2 horas
            const programadosVencendo = requestListEntregue.requests.filter(
              (request) =>
                request.tipoAtendimento === 'programado' &&
                request.slaDate &&
                (() => {
                  const sla = new Date(request.slaDate).getTime();
                  const now = Date.now();
                  const diffHours = (sla - now) / (1000 * 60 * 60);
                  return diffHours <= 1;
                })()
            );

            if (vitals.length > 0 || programadosVencendo.length > 0) {
              return (
                <div className="w-full px-4 py-2 bg-yellow-100 text-yellow-800 rounded text-xs font-semibold border border-yellow-300 animate-pulse-fast">
                  {vitals.length > 0 && (
                    <span>
                      {vitals.length} VITAL &nbsp;
                    </span>
                  )}
                  {vitals.length > 0 && programadosVencendo.length > 0 && <span> | &nbsp; </span>}
                  {programadosVencendo.length > 0 && (
                    <span>
                      {programadosVencendo.length} PROGRAMADO &nbsp;
                    </span>
                  )}
                  <span>
                    aguardando fechamento no SIGTM
                  </span>
                </div>
              );
            }
            return null;
          })()}

        {/* Tabela NOVOS */}
        <div className="flex flex-col w-full border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["NOVO"]?.cor}
              size={15}
            />
            NOVOS
          </div>
          <div className="w-full flex flex-col gap-4 mt-2">

            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead className="text-black"
                style={{ backgroundColor: StatusRequests["NOVO"]?.cor }}>
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                    <th className="py-2 px-4 border-b">Nº da Solicitação</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Furto/Vand.</th>
                    <th className="py-2 px-4 border-b">DRS Origem</th>
                    <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                    <th className="py-2 px-4 border-b">Atendimento</th>
                    <th className="py-2 px-4 border-b">Técnico</th>
                    <th className="py-2 px-4 border-b">Tipo Boleto</th>
                    <th className="py-2 px-4 border-b">Cidade</th>
                    <th className="py-2 px-4 border-b">ID Boleto</th>
                    <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA ou Programado<FaLongArrowAltDown /></div></th>
                    <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {requestListNovos.requests?.map((request, index) => (
                    <tr
                      key={`request-${index}`}
                      className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                        ? "bg-red-100"
                        : isSLANear(request.slaDate)
                          ? "bg-yellow-100"
                          : isSLATwoHour(request.slaDate)
                            ? "bg-yellow-200"
                            : ""
                        }`}
                    >
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          <FaCircle
                          color={StatusRequests[request?.status]?.cor}
                          size={15}
                          className=" animate-pulse-mid"
                        />
                        {request.status}
                        </div>
                      </td>
                      <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={()=>handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                      <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                      <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                      <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                      <td className="py-1 px-4">{request.drsOriginal.sigla}</td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                            <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                              {request.tipoAtendimento.toUpperCase()}
                            </span>
                          ) : (
                            request.tipoAtendimento.toUpperCase()
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4">{request.tecnico}</td>
                      <td className="py-1 px-4">{request.tipoBoleto.toUpperCase()}</td>
                      <td className="py-1 px-4">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</td>
                      <td className="py-1 px-4">{request.idBoleto}</td>
                      <td
                        className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                          ? "text-red-500 font-bold"
                          : request?.slaDate && isSLANear(request.slaDate)
                            ? "text-yellow-600 font-bold"
                            : request?.slaDate && isSLATwoHour(request.slaDate)
                              ? "text-yellow-600 font-bold animate-pulse-fast"
                              : ""
                          }`}
                      >
                        <div className="flex gap-1 items-center font-bold">
                          {request?.slaDate
                            ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                            : "N/A"}
                          {request?.slaDate && isSLATwoHour(request.slaDate) && (
                            <RiTimerLine size={12} />
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center gap-2 h-5 text-[11px]">
                          <button
                            className="flex items-center gap-1 bg-sky-700 rounded-full px-2 text-white"
                            onClick={()=>handleInitiateRequestModal(request._id, request.idRequest)}
                          >
                            <MdCallMade />
                            Atender
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageNovos === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeNovos(currentPageNovos - 1)}
                disabled={currentPageNovos === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListNovos.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageNovos === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeNovos(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageNovos === requestListNovos.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeNovos(currentPageNovos + 1)}
                disabled={currentPageNovos === requestListNovos.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>

        </div>

        {/* Tabela Backoffice */}
        <div className="flex flex-col w-full border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["BACKOFFICE"]?.cor}
              size={15}
            />
            BACKOFFICE
          </div>
          <div className="w-full flex flex-col gap-4">

          <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
              <div className="flex space-x-4 text-[12px]">
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Pesquisar</label>
                  <input
                    type="text"
                    placeholder="Search"
                    value={tempSearch}  // Vincula o valor ao estado temporário
                    onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                    onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                    className="block w-full rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Início</label>
                  <input
                    type="date"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    className="block w-full rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Fim</label>
                  <input
                    type="date"
                    placeholder="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    className="block w-full rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                {/* <div className="flex flex-col">
                  <label className="text-sm font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}
              </div>

              <div className="flex gap-2">
                {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-6 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Limpar Filtros
                </button>             
              </div>
          </div>

            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead style={{ backgroundColor: StatusRequests["BACKOFFICE"]?.cor }}>
                  <tr>
                    {/* <th className="py-2 px-4 border-b rounded-tl-lg">Status</th> */}
                    <th className="py-2 px-4 border-b rounded-tl-lg">Agente</th>
                    <th className="py-2 px-4 border-b">Nº da Solicitação</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Furto/Vand.</th>
                    <th className="py-2 px-4 border-b">DRS Origem</th>
                    <th className="py-2 px-4 border-b">Qtd Solicitada</th>
                    <th className="py-2 px-4 border-b">Qtd Atender</th>
                    <th className="py-2 px-4 border-b">Atendimento</th>
                    <th className="py-2 px-4 border-b">Técnico</th>
                    <th className="py-2 px-4 border-b">Tipo Boleto</th>
                    <th className="py-2 px-4 border-b">Cidade</th>
                    <th className="py-2 px-4 border-b">ID Boleto</th>
                    <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA ou Programado<FaLongArrowAltDown /></div></th>
                    <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {requestListBackoffice.requests?.map((request, index) => (
                    <tr
                      key={`request-${index}`}
                      className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                        ? "bg-red-100"
                        : isSLANear(request.slaDate)
                          ? "bg-yellow-100"
                          : isSLATwoHour(request.slaDate)
                            ? "bg-yellow-200"
                            : ""
                        }`}
                    >
                      {/* <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          <FaCircle
                          color={"#fde047"}
                          size={15}
                        />
                        {request.status}
                        </div>
                      </td> */}
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.agent?.name}</div></td>
                      <td className="py-1 px-4 cursor-pointer underline font-bold whitespace-nowrap" onClick={()=>handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                      <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                      <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                      <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                      <td className="py-1 px-4">{request.drsOriginal.sigla}</td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                            <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                              {request.tipoAtendimento.toUpperCase()}
                            </span>
                          ) : (
                            request.tipoAtendimento.toUpperCase()
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4">{request.tecnico ? request.tecnico : request.user.name}</td>
                      <td className="py-1 px-4">{request.tipoBoleto.toUpperCase()}</td>
                      <td className="py-1 px-4">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</td>
                      <td className="py-1 px-4">{request.idBoleto}</td>
                      <td
                        className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                          ? "text-red-500 font-bold"
                          : request?.slaDate && isSLANear(request.slaDate)
                            ? "text-yellow-600 font-bold"
                            : request?.slaDate && isSLATwoHour(request.slaDate)
                              ? "text-yellow-600 font-bold animate-pulse-fast"
                              : ""
                          }`}
                      >
                        <div className="flex gap-1 items-center font-bold">
                          {request?.slaDate
                            ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                            : "N/A"}
                          {request?.slaDate && isSLATwoHour(request.slaDate) && (
                            <RiTimerLine size={12} />
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center gap-2 h-5 text-[11px]">
                          <button
                            className="flex items-center gap-1 bg-sky-700 rounded-full px-2 text-white"
                            onClick={()=>handleAnswerRequest(request._id, request.idRequest)}
                          >
                            <IoIosSend  />
                            Depósito
                          </button>
                          <button 
                            className="flex items-center gap-1 bg-rose-800 rounded-full px-2 text-white"
                            onClick={()=>handleGestao(request._id, request.idRequest)}
                          >
                            Gestão
                            <AiFillAlert />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageBackoffice === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeBackoffice(currentPageBackoffice - 1)}
                disabled={currentPageBackoffice === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListBackoffice.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageBackoffice === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeBackoffice(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageBackoffice === requestListBackoffice.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeBackoffice(currentPageBackoffice + 1)}
                disabled={currentPageBackoffice === requestListBackoffice.totalPages}
              >
                {'>'}
              </button>
            </div>
          </div>

        </div>

        {/* Tabela Entregues Aguardando fechamento */}
        <div className="flex flex-col w-full border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["ENTREGUE"]?.cor}
              size={15}
            />
            ENTREGUE (Aguardando fechamento SIGTM)
          </div>
          <div className="w-full mt-2">
            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead className="text-white"
                    style={{ backgroundColor: StatusRequests["ENTREGUE"]?.cor }}>
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                    <th className="py-2 px-4 border-b">ID</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Furto/Vand.</th>
                    <th className="py-2 px-4 border-b">DRS Atendido</th>
                    <th className="py-2 px-4 border-b">Cidade</th>
                    <th className="py-2 px-4 border-b">Qtdade</th>
                    <th className="py-2 px-4 border-b">Atendimento</th>
                    <th className="py-2 px-4 border-b">Técnico</th>
                    {/* <th className="py-2 px-4 border-b">Telefone</th> */}
                    <th className="py-2 px-4 border-b">Recebido Por</th>
                    <th className="py-2 px-4 border-b">Obs Entrega</th>
                    <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                    <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {requestListEntregue.requests?.map((request, index) => (
                    <tr
                      key={`request-${index}`}
                      className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                        ? "bg-red-100"
                        : isSLANear(request.slaDate)
                          ? "bg-yellow-100"
                          : isSLATwoHour(request.slaDate)
                            ? "bg-yellow-200"
                            : ""
                        }`}
                    >
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          <FaCircle
                          color={"#0369a1"}
                          size={15}
                        />
                        {request.status}
                        </div>
                      </td>
                      <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={()=>handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                      <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                      <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                      <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeSolicitada}</div></td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center items-center gap-2">
                          {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                            <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                              {request.tipoAtendimento.toUpperCase()}
                            </span>
                          ) : (
                            request.tipoAtendimento.toUpperCase()
                          )}
                        </div>
                      </td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico ? request.tecnico + "-" +request.telefone: request.user.name + "-" +request.user.phone}</div></td>
                      {/* <td className="py-1 px-4">{request.telefone}</td> */}
                      <td className="py-1 px-4">{request.recebidoPor}</td>
                      <td className="py-1 px-4">{request.ultimaObs}</td>
                      <td
                        className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                          ? "text-red-500 font-bold"
                          : request?.slaDate && isSLANear(request.slaDate)
                            ? "text-yellow-600 font-bold"
                            : request?.slaDate && isSLATwoHour(request.slaDate)
                              ? "text-yellow-600 font-bold animate-pulse-fast"
                              : ""
                          }`}
                      >
                        <div className="flex gap-1 items-center font-bold">
                          {request?.slaDate
                            ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                            : "N/A"}
                          {request?.slaDate && isSLATwoHour(request.slaDate) && (
                            <RiTimerLine size={12} />
                          )}
                        </div>
                                              </td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center gap-2 h-5 text-[11px]">
                          <button
                            className=" bg-green-600 rounded-full px-2 text-white"
                            onClick={()=>handleFinalizar(request._id, request.idRequest)}
                          >
                            Finalizar
                          </button>

                          {/* Tramitar na Vivo (Maestro) — em teste, liberado
                              apenas para os e-mails de EMAILS_TRAMITAR_MAESTRO. */}
                          {podeTramitar &&
                            <button
                              disabled={tramitandoId === request._id}
                              title={`Tramitar o TA ${request.idBoleto} na Vivo`}
                              className="bg-purple-600 rounded-full px-2 text-white hover:bg-purple-700 disabled:bg-gray-300 whitespace-nowrap"
                              onClick={()=>handleTramitar(request._id, request.idBoleto)}
                            >
                              {tramitandoId === request._id ? "Tramitando..." : "Tramitar"}
                            </button>
                          }
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageEntregue === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeEntregue(currentPageEntregue - 1)}
                disabled={currentPageEntregue === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListEntregue.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageEntregue === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeEntregue(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageEntregue === requestListEntregue.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeEntregue(currentPageEntregue + 1)}
                disabled={currentPageEntregue === requestListEntregue.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>

      {requestOnAnswerModal && 
      <div className="absolute">
        <SendToWarehouseModal
          isModalOpen={sendToWarehouseModal}
          setModalOpen={() => {
            setSendToWarehouseModal(!sendToWarehouseModal);
          }}
          requestId={requestOnAnswerModal}
          requestNro={requestNroOnAnswerModal}
          // setTicketCb={setTicket}
        ></SendToWarehouseModal>
      </div>
      }

      { requestOnMngtModal && 
      <div className="absolute">
        <SendToManagementModal
          isModalOpen={sendToManagementModal}
          setModalOpen={() => {
            setSendToManagementModal(!sendToManagementModal);
          }}
          requestId={requestOnMngtModal}
          // requestNro={requestNroOnMngtModal}
          // setTicketCb={setTicket}
        ></SendToManagementModal>
      </div>
      }

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      {requestOnFinishModal && 
      <div className="absolute">
        <FinishModal
          isModalOpen={finishModal}
          setModalOpen={() => {
            setFinishModal(!finishModal);
          }}
          requestId={requestOnFinishModal}
          requestNro={requestNroOnFinishModal}
          // setTicketCb={setTicket}
        ></FinishModal>
      </div>
      }

      { requestOnInitiateRequestModal &&
      <div className="absolute">
        <InitiateRequestModal
          isModalOpen={initiateRequestModal}
          setModalOpen={() => {
            setInitiateRequestModal(!initiateRequestModal);
          }}
          requestId={requestOnInitiateRequestModal}
          requestNro={requestNroOnInitiateRequestModal}
          // setTicketCb={setTicket}
        ></InitiateRequestModal>
      </div>
      }

    </div>
  );
}

export default Home;
